export const PATH_PLANS_OFFERS = '/services/plans/v2/offers';